import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC } from "react";

type Props = WidgetProps;

export interface CategoryDetailSubCustomContainerStyles {
    container?: GridContainerProps;
    leftColumnGridItemStyle?: GridItemProps;
    rightColumnGridItemStyle?: GridItemProps;
}

export const categoryDetailSubCustomContainerStyles: CategoryDetailSubCustomContainerStyles = {
    container: {
        gap: 20,
    },
    leftColumnGridItemStyle: {
        width: [12, 12, 8, 8, 8],
    },
    rightColumnGridItemStyle: {
        width: [12, 12, 4, 4, 4],
    },
};

const styles = categoryDetailSubCustomContainerStyles;

const CategoryDetailSubCustomContainer: FC<Props> = ({ id }) => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.leftColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>
            <GridItem {...styles.rightColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: CategoryDetailSubCustomContainer,
    definition: {
        group: "Common",
        displayName: "Category Details Container",
    },
};

export default widgetModule;
